/**
 * RequireCandidate - Route guard for candidate-only pages.
 * Redirects to /candidat/login if no candidate token.
 */
import { Navigate, useLocation } from "react-router-dom";
import { useCandidateAuth } from "@/context/CandidateAuthContext";

export default function RequireCandidate({ children }) {
  const { isAuthenticated } = useCandidateAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/candidat/login" state={{ from: location }} replace />;
  }

  return children;
}
